import { NotificationRepository } from "@core/data/repositories/notification.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { Notification } from "@core/domain/models/notification.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class GetMyNotificationsUseCase {
    constructor(
        @inject(NotificationRepository)
        private readonly repository: NotificationRepository,
    ) {}

    execute(limit?: number): Promise<Either<FallbackError, Notification[]>> {
        return this.repository.fetchMy(limit);
    }
}
